import React, { useState, useEffect } from 'react';
import { api } from '../api';

export default function MyAccount({ user, onClose }) {
  const [profile, setProfile] = useState(null);
  const [form, setForm] = useState({});
  const [password, setPassword] = useState('');
  const [confirm, setConfirm] = useState('');
  const [saving, setSaving] = useState(false);
  const [success, setSuccess] = useState('');
  const [error, setError] = useState('');
  const [activeTab, setActiveTab] = useState('info');

  useEffect(() => {
    api.getProfile().then(p => {
      setProfile(p);
      setForm({
        name:           p.name || '',
        email:          p.email || '',
        phone:          p.phone || '',
        birthday:       p.birthday || '',
        abn:            p.abn || '',
        bsb:            p.bsb || '',
        account_number: p.account_number || '',
      });
    }).catch(console.error);
  }, []);

  async function handleSave(e) {
    e.preventDefault();
    setError(''); setSaving(true);
    try {
      const payload = { ...form };
      if (password) {
        if (password !== confirm) { setError('Passwords do not match'); setSaving(false); return; }
        payload.password = password;
      }
      await api.updateProfile(payload);
      setSuccess('Profile saved!');
      setPassword(''); setConfirm('');
      setTimeout(() => setSuccess(''), 3000);
    } catch (err) { setError(err.message); }
    finally { setSaving(false); }
  }

  const typeLabel = {
    admin: 'Admin', commissioned: 'Commissioned',
    hourly: 'Hourly', office_cleaner: 'Office Cleaner',
  }[user.type] || user.type;

  const tabs = ['info', 'financial', 'password'];

  return (
    <div style={{ position: 'fixed', inset: 0, background: 'rgba(0,0,0,0.6)', display: 'flex', alignItems: 'center', justifyContent: 'center', zIndex: 2000, padding: 16 }}>
      <div className="card account-modal-inner" style={{ width: 520, maxWidth: '95vw', maxHeight: '90vh', overflow: 'auto', margin: 0 }}>
        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 4 }}>
          <div>
            <h3 style={{ margin: 0 }}>My Account</h3>
            <p style={{ margin: '4px 0 0', fontSize: 13, color: '#6b7280' }}>
              {profile?.name} · <span style={{ textTransform: 'capitalize' }}>{typeLabel}</span> · @{profile?.username}
            </p>
          </div>
          <button className="btn btn-ghost btn-sm" onClick={onClose}>✕</button>
        </div>

        {/* Tabs */}
        <div style={{ display: 'flex', gap: 4, margin: '16px 0 20px', borderBottom: '1px solid #e5e7eb', paddingBottom: 4 }}>
          {tabs.map(t => (
            <button key={t} type="button"
              style={{
                padding: '6px 16px', border: 'none', background: 'transparent',
                fontWeight: 600, fontSize: 13, cursor: 'pointer',
                color: activeTab === t ? '#4A7A91' : '#9ca3af',
                borderBottom: activeTab === t ? '2px solid #4A7A91' : '2px solid transparent',
              }}
              onClick={() => setActiveTab(t)}>
              {t === 'info' ? 'Personal Info' : t === 'financial' ? 'Financial' : 'Password'}
            </button>
          ))}
        </div>

        {success && <div className="alert alert-success">{success}</div>}
        {error   && <div className="alert alert-error">{error}</div>}

        {!profile ? (
          <div style={{ textAlign: 'center', padding: 32, color: '#6b7280' }}>Loading...</div>
        ) : (
          <form onSubmit={handleSave}>
            {activeTab === 'info' && (
              <div className="account-form-grid" style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 14 }}>
                <div className="form-group" style={{ marginBottom: 0, gridColumn: '1 / -1' }}>
                  <label>Full Name</label>
                  <input value={form.name} onChange={e => setForm({ ...form, name: e.target.value })} required />
                </div>
                <div className="form-group" style={{ marginBottom: 0 }}>
                  <label>Email</label>
                  <input type="email" value={form.email} onChange={e => setForm({ ...form, email: e.target.value })} />
                </div>
                <div className="form-group" style={{ marginBottom: 0 }}>
                  <label>Phone</label>
                  <input value={form.phone} onChange={e => setForm({ ...form, phone: e.target.value })} />
                </div>
                <div className="form-group" style={{ marginBottom: 0 }}>
                  <label>Birthday</label>
                  <input type="date" value={form.birthday} onChange={e => setForm({ ...form, birthday: e.target.value })} />
                </div>
                <div className="form-group" style={{ marginBottom: 0 }}>
                  <label>Start Date</label>
                  <input type="date" value={profile.start_date || ''} disabled style={{ background: '#f9fafb', color: '#9ca3af' }} />
                </div>
              </div>
            )}

            {activeTab === 'financial' && (
              <div className="account-form-grid" style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 14 }}>
                <div style={{ gridColumn: '1 / -1', background: '#f4f8fa', borderRadius: 8, padding: 12, fontSize: 13, color: '#6b7280', borderLeft: '3px solid #4A7A91' }}>
                  These details appear on your invoices. Keep them accurate.
                </div>
                <div className="form-group" style={{ marginBottom: 0, gridColumn: '1 / -1' }}>
                  <label>ABN (Australian Business Number)</label>
                  <input value={form.abn} onChange={e => setForm({ ...form, abn: e.target.value })} placeholder="XX XXX XXX XXX" />
                </div>
                <div className="form-group" style={{ marginBottom: 0 }}>
                  <label>BSB</label>
                  <input value={form.bsb} onChange={e => setForm({ ...form, bsb: e.target.value })} placeholder="000-000" />
                </div>
                <div className="form-group" style={{ marginBottom: 0 }}>
                  <label>Account Number</label>
                  <input value={form.account_number} onChange={e => setForm({ ...form, account_number: e.target.value })} />
                </div>
              </div>
            )}

            {activeTab === 'password' && (
              <div style={{ display: 'grid', gap: 14 }}>
                <div style={{ background: '#fef3c7', borderRadius: 8, padding: 12, fontSize: 13, color: '#92400e' }}>
                  Leave both fields empty to keep your current password.
                </div>
                <div className="form-group" style={{ marginBottom: 0 }}>
                  <label>New Password</label>
                  <input type="password" value={password} onChange={e => setPassword(e.target.value)} placeholder="Enter new password" />
                </div>
                <div className="form-group" style={{ marginBottom: 0 }}>
                  <label>Confirm New Password</label>
                  <input type="password" value={confirm} onChange={e => setConfirm(e.target.value)} placeholder="Repeat new password" />
                </div>
              </div>
            )}

            <div style={{ display: 'flex', gap: 8, marginTop: 20, justifyContent: 'flex-end', flexWrap: 'wrap' }}>
              <button type="button" className="btn btn-ghost" onClick={onClose} style={{ flex: '0 0 auto' }}>Cancel</button>
              <button type="submit" className="btn btn-primary mobile-btn-full" disabled={saving} style={{ flex: 1 }}>
                {saving ? 'Saving...' : 'Save Changes'}
              </button>
            </div>
          </form>
        )}
      </div>
    </div>
  );
}
